import { architeckCall } from 'database';
import moment from 'moment';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, CardText, Col, Container, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

class CompanyRequests extends React.Component {

    state = {
        loaded: false,
        requests: [],
        canSave: true
    }

    componentWillMount = async () => {

        if(!this.props.viewing_user.company) {
            return;
        }

        const requests = await architeckCall({
            method: 'get',
            url: `/api/v1/requests/list?find_by=company__${this.props.viewing_user.company._id}`
        })

        if(requests.success) {

            this.setState({requests: requests.data, loaded: true})

        } else {

            toggleAlert(true, 'danger', `Something went wrong fetching project requests.`, 'infinite' )
            console.log(requests);

        }


    }
    
    render() {

        const requests = this.state.requests

        return (
            <>

            <Container>     

                <Helmet>
                    <title>Requests</title>
                    <meta name="description" content="Requests" />
                </Helmet>

                {this.state.alert}

                <Card className="mt-4 ">

                    <CardHeader>
                        <h2 className="mb-0">Project Requests</h2>
                    </CardHeader>

                    <CardBody>
                        <Row>
                            <Col lg={2}>
                                <img className="w-100" src={require('assets/img/misc/Requests.svg')} alt="..." />
                            </Col>
                            <Col lg={10}>
                                <h4  className="mt-2 mt-lg-0">For whatever is on your mind.</h4>
                                <p>On this page you can view all of your companies previously submitted project updates and feature requests. If you would like to submit a new request you may do so under the Updates / Revisions tab on the project you would like to submit a request for.</p>
                            </Col>
                        
                        </Row>

                    </CardBody>
                </Card>

                {this.state.loaded ? (
                    <>
                        <hr />

                        <Row >

                            {requests.length ? requests.map((p, i) => (
                                <Col key={p._id} xl={11} className={i % 2  ? "offset-lg-1" : null}>
                                        <Card className="mb-4">
                                            <CardHeader className="">
                                                <h2 className="mb-0">{ moment.unix(p.created_at).format("MM/DD/YYYY")}</h2>
                                                <h5 className="text-muted mb-0">{p.project.name}</h5>

                                            </CardHeader>
                                            <CardBody>

                                                <CardText>
                                                    <b>Submitted By: {p.user.given_name}{' '}{p.user.family_name}</b>
                                                </CardText>

                                                <CardText>
                                                    {p.description}
                                                </CardText>
                                            
                                            </CardBody>
                                        </Card>
                                </Col>
                            )): (
                                <Col xs={12}>
                                    <Card>
                                        <CardBody>
                                            <h2 className="mb-0">Your company has not submitted any project feature requests or updates.</h2>
                                        </CardBody>
                                    </Card>
                                </Col>

                            )}
                        </Row>

                        <hr className="mt-0"/>
                    </>
                ) : null}

            </Container>
            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
  
    };
};
  
export default connect(mapStateToProps, '')(CompanyRequests);